import { TableBody } from "@mui/material";
import { ErrorBoundary } from "@platform/design-system";

import {
  POLICY_VARIANT_AQUAFINA_COVERAGE_TYPE_MAPPING,
  PolicyVariants,
  VIEW_MODES,
} from "../../constants";
import {
  AccidentCoverage,
  BasicLifeCoverage,
  CriticalIllnessCoverage,
  DentalCoverage,
  HospitalIndemnityCoverage,
  LtdCoverage,
  MedicalCoverage,
  Proposal,
  StdCoverage,
  VisionCoverage,
  VoluntaryLifeCoverage,
} from "../../constants/aquafina";
import Ltd from "../coverages/ltd";
import Std from "../coverages/std";
import Vision from "../coverages/vision";
import BasicLife from "../coverages/basic-life";
import VoluntaryLife from "../coverages/voluntary-life";
import Medical from "../coverages/medical";
import Accident from "../coverages/accident";
import CriticalIllness from "../coverages/critical-illness";
import Hospital from "../coverages/hospital";
import Dental from "../coverages/dental";
import NoInformation from "../no-information";
import { PlanErrorBoundaryFallback } from "../plan-error-boundary-fallback";

type ProposalDetailProps = {
  proposalDetail: Proposal;
  variant: PolicyVariants;
  displayV4Fields: boolean;
};

export const ProposalDetail = ({
  proposalDetail,
  variant,
  displayV4Fields,
}: ProposalDetailProps) => {
  const coverageType = POLICY_VARIANT_AQUAFINA_COVERAGE_TYPE_MAPPING[variant];
  const { [coverageType]: coverage } = proposalDetail;

  if (!coverage) {
    return <NoInformation />;
  }

  return (
    <ErrorBoundary fallback={PlanErrorBoundaryFallback}>
      <TableBody>
        {coverageType === "dental" && (
          <Dental
            viewMode={VIEW_MODES.PROPOSAL}
            coverage={coverage as DentalCoverage}
            variant={variant}
            displayV4Fields={displayV4Fields}
          />
        )}
        {coverageType === "ltd" && (
          <Ltd
            coverage={coverage as LtdCoverage}
            viewMode={VIEW_MODES.PROPOSAL}
            displayV4Fields={displayV4Fields}
          />
        )}
        {coverageType === "std" && (
          <Std
            coverage={coverage as StdCoverage}
            viewMode={VIEW_MODES.PROPOSAL}
            displayV4Fields={displayV4Fields}
          />
        )}
        {coverageType === "vision" && (
          <Vision
            coverage={coverage as VisionCoverage}
            viewMode={VIEW_MODES.PROPOSAL}
            displayV4Fields={displayV4Fields}
          />
        )}
        {coverageType === "basicLife" && (
          <BasicLife
            coverage={coverage as BasicLifeCoverage}
            viewMode={VIEW_MODES.PROPOSAL}
            displayV4Fields={displayV4Fields}
          />
        )}
        {coverageType === "volLife" && (
          <VoluntaryLife
            coverage={coverage as VoluntaryLifeCoverage}
            viewMode={VIEW_MODES.PROPOSAL}
            displayV4Fields={displayV4Fields}
          />
        )}
        {coverageType === "medical" && (
          <Medical coverage={coverage as MedicalCoverage} />
        )}
        {coverageType === "accident" && (
          <Accident
            viewMode={VIEW_MODES.PROPOSAL}
            coverage={coverage as AccidentCoverage}
            displayV4Fields={displayV4Fields}
          />
        )}
        {coverageType === "criticalIllness" && (
          <CriticalIllness
            viewMode={VIEW_MODES.PROPOSAL}
            coverage={coverage as CriticalIllnessCoverage}
            displayV4Fields={displayV4Fields}
          />
        )}
        {coverageType === "hospitalIndemnity" && (
          <Hospital
            viewMode={VIEW_MODES.PROPOSAL}
            coverage={coverage as HospitalIndemnityCoverage}
            displayV4Fields={displayV4Fields}
          />
        )}
      </TableBody>
    </ErrorBoundary>
  );
};

export default ProposalDetail;
